import { getAppContext } from '@b2ag/micro-front-tools'

const { isFrontTech } = getAppContext()

/* ------- CONTEXTS - ARTICLES ------- */

const VUniversePage = () => import('@b2ag/articles/src/application/view/VUniversePage/VUniversePage.vue')
const VArticlePage = () => import('@b2ag/articles/src/application/view/VArticlePage/VArticlePage.vue')
const VHubPage = () => import('@b2ag/articles/src/application/view/VHubPage/VHubPage.vue')
const VHubDirectory = () => import('@b2ag/articles/src/application/view/VHubDirectory/VHubDirectory.vue')

export const articlesRoutes = [
  { path: '/universe/:slug', name: 'univers', component: VUniversePage },
  {
    path: '/article/:slug',
    name: 'article-page',
    component: VArticlePage,
    props: () => ({
      excludeComponents: isFrontTech ? ['newsletter', 'breadcrumb', 'tags-links', 'social-share'] : undefined,
    }),
    meta: {
      disabledLayoutAlternate: true,
    },
  },
  { path: '/news/:slug', name: 'hub-page', component: VHubPage },
  { path: '/all-news', name: 'annuaire', component: VHubDirectory },
]
